/**
 * @generated SignedSource<<9b06a445568c28dea49e9f2624dc4f2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntityHistoryJsonContext_entry$data = {
  readonly context: string | null;
  readonly " $fragmentType": "EntityHistoryJsonContext_entry";
};
export type EntityHistoryJsonContext_entry$key = {
  readonly " $data"?: EntityHistoryJsonContext_entry$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityHistoryJsonContext_entry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityHistoryJsonContext_entry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "context",
      "storageKey": null
    }
  ],
  "type": "LogEntry",
  "abstractKey": null
};

(node as any).hash = "8a59c201cac37edfc6f3ef2a2dfd3bbc";

export default node;
